@if ({r: result$ | async, l: loading$ | async}; as type) {
  @if (contentSearchData) {
    @if (entries && entries.length > 0) {
      <div>
        <span><b>{{ 'contentSearch.header' | cxTranslate : { count: entries.length } }}</b></span>
        <br><br>
      </div>
    }
    @if (suggestion) {
      <div>
        <span>{{ 'contentSearch.suggestion' | cxTranslate }}<a [routerLink]="
        {
          cxRoute: 'contentSearch',
          params: {query: suggestion}
        } | cxUrl
      ">{{suggestion}}</a>?</span>
        <br><br>
      </div>
    }
    @if (
      entries && entries.length > 0) {
      @for (entry of entries; track entry) {
        <div>
          <a [routerLink]="entry.link" [innerHTML]=" entry.title"></a><br>
          <span [innerHTML]="entry.textSnippet"></span>
        </div>
      }
    } @else {
      <div>
        <b>{{ 'contentSearch.notFound' | cxTranslate }}</b>
      </div>
    }
  } @else {
    <cx-spinner></cx-spinner>
  }
}